/* eslint-disable */
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import styles from './HeaderAndFooter.module.css';
import { Header } from '../../components';
import Sidebar from '../../components/SideBar/SideBar';

const HeaderAndFooter = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [pageName, setPageName] = useState('');
  const [rotate, setRotate] = useState(false);
  
  return (

    <div className={styles.wrapper}>
      <Header isRotate={rotate}  notRotate={setRotate} isOpen={isSidebarOpen} isClose={setSidebarOpen} PageName={pageName}/>
      <div className={styles.body}>
        <Sidebar isRotate={rotate}  notRotate={setRotate} isOpen={isSidebarOpen} isClose={setSidebarOpen} onPageChange={setPageName} />
        <div className={styles.renderArea}>{children}</div>
      </div>
    </div>

  )
};

HeaderAndFooter.propTypes = {
  children: PropTypes.any,
};

export default HeaderAndFooter;
